import { type AnalyticsErrorCategory } from '@imagise/shared';

export function getEditorAnalyticsErrorCategory(error: unknown): AnalyticsErrorCategory {
  const status = typeof error === 'object' && error !== null ? Reflect.get(error, 'status') : undefined;

  if (status === 0) {
    return 'network';
  }
  if (status === 415) {
    return 'unsupported';
  }
  if (typeof status === 'number' && status >= 500) {
    return 'server';
  }
  if (typeof status === 'number' && status >= 400) {
    return 'validation';
  }
  if (
    (typeof DOMException !== 'undefined' && error instanceof DOMException) ||
    (typeof ProgressEvent !== 'undefined' && error instanceof ProgressEvent)
  ) {
    return 'client_read';
  }

  return 'unknown';
}
